import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Image, theme, Upload } from "antd";
import React, { useEffect, useRef, useState } from 'react';
import ImageDefault from "../../../../assets/icon/vessel_image_default.svg";
import S3Image from "../../../../components/S3Image";
import { useEditVessel } from "../../../../contexts/EditVesselContext";
import styles from "../style.module.scss";

interface IProps {

}

const VesselImage: React.FC<IProps> = () => {
    const imgRef = useRef<any>(null);
    const closeTimer = useRef<ReturnType<typeof setTimeout>>();
    const [previewKey, setPreviewKey] = useState(0);
    const { token } = theme.useToken();
    const [image_url, setStore] = useEditVessel(state => state.vessel?.image_url);
    const [file] = useEditVessel(state => state.file);

    useEffect(() => () => clearTimeout(closeTimer.current), []);

    const onPreviewOpenChange = (open: boolean) => {
        clearTimeout(closeTimer.current);
        if (!open) {
            // Allow the fade to finish, then release a portal stuck in leave-active.
            const duration = token.motion ? parseFloat(token.motionDurationSlow) * 1000 : 0;
            closeTimer.current = setTimeout(() => setPreviewKey(key => key + 1), duration + 100);
        }
    };

    const onDelete = (e: React.MouseEvent) => {
        setStore({ file: null });
        e.stopPropagation();
    }

    const onEdit = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (imgRef.current) {
            const inputRef = imgRef.current?.nativeElement.getElementsByTagName('input')[0];
            if (inputRef)
                inputRef.click();
        }
    }

    return <div>
        <div className={styles.img}>
            <Upload
                ref={imgRef}
                showUploadList={false}
                className={styles.upload}
                fileList={file ? [file] : []}
                multiple={false}
                onRemove={() => {
                    setStore({ file });
                }}
                beforeUpload={(file: any) => {
                    setStore({ file });
                    return false;
                }}
            />
            {file ? <Image key={previewKey} {...{
                width: '100%',
                src: URL.createObjectURL(file),
                fallback: ImageDefault,
                preview: {
                    onOpenChange: onPreviewOpenChange,
                    cover: <div className={styles.actionImg}>
                        <div className={styles.edit} onClick={onEdit}>
                            <EditOutlined />
                        </div>
                        <div className={styles.delete} onClick={onDelete}>
                            <DeleteOutlined />
                        </div>
                    </div>
                },
            }} /> : <S3Image
                key={previewKey}
                preview={{
                    onOpenChange: onPreviewOpenChange,
                    cover: <div className={styles.action}>
                        <div className={styles.edit} onClick={onEdit}>
                            <EditOutlined />
                        </div>
                    </div>
                }}
                imageUrl={image_url || ''}
                height={image_url ? 210 : 180}
            />}
        </div>
        <div className='text-comment italic mt-1'>JPG, GIF or PNG. Max size of 800K</div>
    </div>;
};

export default VesselImage;
